import React, { useEffect, useRef } from 'react';

const VideoCall = ({ roomName, userName, onLeave }) => {
    const jitsiContainerRef = useRef(null);
    const apiRef = useRef(null);

    useEffect(() => {
        const domain = 'meet.jit.si';
        const options = {
            roomName,
            parentNode: jitsiContainerRef.current,
            width: '100%',
            height: 500,
            userInfo: {
                displayName: userName || 'Convidado'
            },
            configOverwrite: {
                startWithAudioMuted: true,
                startWithVideoMuted: false,
            },
            interfaceConfigOverwrite: {
                SHOW_JITSI_WATERMARK: false,
                SHOW_BRAND_WATERMARK: false,
                SHOW_POWERED_BY: false,
                TOOLBAR_BUTTONS: [
                    'microphone', 'camera', 'hangup', 'tileview', 'fullscreen'
                ]
            }
        };

        apiRef.current = new window.JitsiMeetExternalAPI(domain, options);

        apiRef.current.addListener('readyToClose', () => {
            onLeave();
        });

        return () => {
            apiRef.current?.dispose();
        };
    }, [roomName, userName, onLeave]);

    return (
        <div>
            <div ref={jitsiContainerRef} />
        </div>
    );
};

export default VideoCall;
